import localStorageAvailable from '../../utils/localStorageAvailable';

const Logout = () => {
  if (localStorageAvailable()) {
    localStorage.removeItem('token');
  }
  window.location.replace('/login');
};

export default Logout;
